import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/template.tsx");
